import { Component, HostListener, Inject, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';

export interface DialogDuplicateCodeData {
  code?: string;
  maxLength: number;
  duplicate: (code: string) => Observable<any>;
}

@Component({
  selector: 'app-dialog-duplicate-code',
  templateUrl: './dialog-duplicate-code.component.html',
  styleUrls: ['./dialog-duplicate-code.component.scss']
})
export class DialogDuplicateCodeComponent {
  @ViewChild('codeModel', { static: true }) codeModel!: NgModel;
  code: string;
  isSaving = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDuplicateCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDuplicateCodeData,
    private snackbarService: SnackbarService
  ) {
    this.code = data.code || '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.isSaving || this.codeModel.invalid || !this.code.trim()) return;

    this.isSaving = true;
    this.data.duplicate(this.code.trim()).subscribe({
      next: (res) => this.dialogRef.close(res),
      error: (error) => {
        this.isSaving = false;
        if (this.snackbarService.isCodeAlreadyExists(error)) {
          this.codeModel.control.setErrors({ codeAlreadyExists: true });
          this.codeModel.control.markAsTouched();
        } else {
          this.snackbarService.openError(error);
          this.dialogRef.close();
        }
      }
    });
  }

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.onSubmit();
  }
}
